// @flow
import {combineReducers} from 'redux';
import {reducer as modularReduxForm} from '@mzvonar/modular-redux-form';
import type { Action } from '../types';
import alerts from './alerts';
import cars from './cars';
import config from './config';
import environment from './environment';
import error from './error';
import app from './app';
import planes from './planes';
import user from './user';
import users from './users';
import vehicles from './vehicles';
import zones from './zones';

const rootReducer = combineReducers<Object, Action>({
    modularReduxForm,

    alerts,
    cars,
    config,
    environment,
    error,
    app,
    planes,
    user,
    users,
    vehicles,
    zones
});

export default rootReducer;